var map = {
	"./breakfast.png": 81463,
	"./desserts.png": 77683,
	"./farm_products.png": 41891,
	"./main.png": 22475,
	"./salads.png": 39402,
	"./snaks.png": 78528,
	"./soups.png": 95794,
	"./upsell.png": 41091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60931;